import React, {Component} from 'react';
import centerIcon from "../../../components/image/center.png";

class FloatCenterTool extends Component {

    onClick = ()=>{
        this.props.editor.execCommand("imagefloat", "center");
    };

    getName(){
        return "floatCenterTool"
    }

    render() {
        return (
            <span>
                <img src={centerIcon} onClick={()=>{this.onClick()}}/>
            </span>
        );
    }}

export default FloatCenterTool;